import { defineComponent as _defineComponent } from 'vue'
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { isPC } from '../../../utils/env';
import store from '@/store';
import { setScore } from '@/api/data';


export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-button',
  props: {
  enableSend: {
    type: Boolean,
    default: true,
  },
},
  emits: ['sendMessage'],
  setup(__props, { emit: emits }) {

const props = __props





const sendMessage = () => {
  store.getters.firstTalk && setScore('消息-回复');
  emits('sendMessage');
};

return { __sfc: true,props, emits, sendMessage, TUITranslateService, isPC }
}

})